import { render, staticRenderFns } from "./kfyView.vue?vue&type=template&id=5b402f5c&scoped=true"
import script from "./kfyView.vue?vue&type=script&lang=js"
export * from "./kfyView.vue?vue&type=script&lang=js"
import style0 from "./kfyView.vue?vue&type=style&index=0&id=5b402f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b402f5c",
  null
  
)

export default component.exports